<template>
    <div class="w-full flex flex-row" >
        <portal-target name="headerBreadCrumb">
        </portal-target>
        <div class="flex flex-grow justify-between">
            <div class="flex text-lg pl-3 font-bold">
                <span class="pr-4 flex items-center">{{routeTitle}}</span>
            </div>
        </div>
        <portal-target name="headerContent">
        </portal-target>
    </div>
</template>
<script>
export default
{
    name: 'HeaderBar',
    props: ['routeTitle']
};
</script>
